module.exports = __webpack_public_path__ + "static/img/lifestyle_38.61bb5010.png";